// Define mappings for size, border, and width classes
export const sizeClass = {
  small: 'my-6',
  medium: 'my-12',
  large: 'my-24',
};

export const widthClass = {
  full: 'w-full',
  half: 'w-1/2',
};
